import React, { useState } from 'react';
import './InputFormTable.style.css';

/**----------------------------------------
 * [Component] 총관리자: 상품등록 > 판매정보 입력폼 > 입력폼
 * ----------------------------------------
 */
const InputFormTable = ({ form = [], labelWidth = 200 }) => {
  /* ===== Route ===== */
  /* ===== Props ===== */
  /* ===== State ===== */
  const [inputLengths, setInputLengths] = useState({});

  /* ===== Hooks ===== */
  /* ===== Function ===== */
  const handleInputChange = (key, event, originalOnChange) => {
    const newLength = event.target.value.length;
    setInputLengths({
      ...inputLengths,
      [key]: newLength,
    });

    // 원래의 onChange 이벤트 핸들러가 있으면 호출
    if (originalOnChange) {
      originalOnChange(event);
    }
  };

  /* ===== Variable ===== */
  /* ===== Hooks ===== */

  /* ===== Render ===== */
  // JSX: start
  return (
    <table className="input_form_table_layout">
      <tbody>
        {form.map((_item, _index) => (
          <tr key={`form_${_index}`}>
            <td
              className="table_label_area"
              style={{ width: labelWidth, ..._item.styles?.label }}
            >
              <div>
                {_item.required && <span className="input_required">*</span>}
                {_item.label}
              </div>
            </td>
            <td className="table_input_area" style={{ ..._item.styles?.input }}>
              <div
                className="table_input_area_input"
                style={{
                  flexDirection: _item.direction ?? 'row',
                  alignItems:
                    _item.direction === 'column' ? 'baseline' : 'center',
                }}
              >
                {_item.form.map((_subitem, _subindex) => (
                  <div
                    className="table_input_area_div"
                    key={`input_${_subindex}`}
                    style={{
                      marginTop:
                        _item.direction === 'column' && _subindex > 0 ? 8 : 0,
                      width: _subitem.fullscreen && '100%',
                      ..._subitem.style,
                    }}
                  >
                    {React.cloneElement(_subitem.input, {
                      onChange: _subitem.count
                        ? (e) =>
                            handleInputChange(
                              `${_index}_${_subindex}`,
                              e,
                              _subitem.input.props.onChange
                            )
                        : _subitem.input.props.onChange,
                      style: {
                        width: _subitem.fullscreen && '100%',
                        ..._subitem.input.props.style,
                      },
                      ..._subitem.input.props,
                    })}
                    {_subitem.count && (
                      <p>
                        <span
                          style={{
                            color:
                              inputLengths[`${_index}_${_subindex}`] >
                                _subitem.maxLength ||
                              !inputLengths[`${_index}_${_subindex}`]
                                ? 'var(--danger-color)'
                                : 'var(--black-color)',
                          }}
                        >
                          {inputLengths[`${_index}_${_subindex}`] ?? 0}
                        </span>
                        /{_subitem.maxLength ?? 30}
                      </p>
                    )}
                  </div>
                ))}
              </div>
              {_item.message && (
                <div className="input_message">{_item.message}</div>
              )}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  ); // JSX: end
};

export default InputFormTable;
